import React from "react";

type AlertIconProps = {
  size?: string; // 아이콘 크기 (px 단위)
  color?: string; // ! 아이콘 색상
  backgroundColor?: string; // 배경색
};

const AlertIcon: React.FC<AlertIconProps> = ({
  size = '24px',
  color = "#FFFFFF",
  backgroundColor = "#000000",
}) => {
  const style: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: `${size}`,
    height: `${size}`,
    borderRadius: "50%", // 원형 배경
    backgroundColor,
    color,
    fontWeight: "bold",
    fontSize: "20px", // 고정된 글자 크기 20px
    position: "absolute", // 위치 지정
    zIndex: 100, // z-index 설정
    top: "8px", // 상단에서 8px
    right: "8px", // 오른쪽에서 8px
    fontFamily: 'Inter bold',
    border: 'solid 1px #ffffff64'
  };

  return <div style={style}>!</div>;
};

export default AlertIcon;